export class HealthHistoryRecentProviderVisitForm {
  constructor(el) {
    el.querySelectorAll('input.recent-provider-radio-button[type="radio"]').forEach((item)=> {
      item.addEventListener("change", (e)=> this.handleCheckBox(e))
    })
  }

  // Handles yes/no checkbox in this section
  handleCheckBox(e) {
    let targetTextArea = e.target.closest('.intake-body-inner').querySelector('textarea')
    let charCounter = e.target.closest('.intake-body-inner').querySelector('span.character-counter')

    if (e.target.value == "true") {
      // Trigger the event listener for "input" to reset char counter
      targetTextArea.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))

      // Show the components
      targetTextArea.classList.remove("hidden")
      charCounter.classList.remove("hidden")

      // Clean up the text area
      targetTextArea.value = ""
    } else {
      // Hide the components
      targetTextArea.classList.add("hidden")
      charCounter.classList.add("hidden")

      // Since this field is mandatory we're going to put "No" text in the textarea
      targetTextArea.value = "No"
    }
  }

}